/** @format */

import { useEffect } from 'react';
import { produce } from 'immer';
import dayjs from 'dayjs';
import { FILTER_NAMES, useAppContext } from '../../store/store.app';
import { modifyValue } from '../../Library/misc.lib';
import { getAttributeValues } from '../../Services/service.drilldown';
import { getUserDetails } from '../../Services/service.home';

const defaultDRange = [
  {
    startDate: dayjs()
      .subtract(1, 'year')
      .startOf('year')
      .add(3, 'month')
      .toDate(), // April 1st of previous year
    endDate: new Date(dayjs()),
    key: 'selection',
  },
];

export function useUserInfo() {
  const appCtx = useAppContext();

  async function fetchData() {
    let userDetails = localStorage.getItem('USER_DETAILS');
    userDetails = JSON.parse(userDetails);

    const {
      data: {
        Value,
        parameters: paramList,
        appFilter: filterSettings,
        leaderBoard,
      },
    } = await getUserDetails({
      Account_Id: userDetails.account_id,
      User_Id: userDetails.user_id,
    });

    localStorage.setItem('params', JSON.stringify(paramList));

    modifyValue(Value, paramList);

    appCtx.updateUserInfo(
      produce(Value, (draft) => {
        // placing the backend param with front-end at one place
        draft.homepage.leaderboard = {
          ...draft.homepage.leaderboard,
          ...leaderBoard, //backend param
        };
      })
    );
    appCtx.updateFilterSettings('filterSettings', filterSettings);

    const { data: attributeValues } = await getAttributeValues({
      Attribute_Name: filterSettings.attribute,
    });

    const { Status, ...attributes } = attributeValues;
    const parameters = Object.entries(attributes).map(([attribute, value]) => {
      const total =
        typeof value[0] === 'number' ? value.map((v) => v.toString()) : value;

      //select "Jw" by default
      let selected = [total[0]];
      if (attribute === 'hotel') {
        const jw = total.find((t) => t === 'Jw');
        selected = [jw ?? total[0]];
      }

      return {
        name: attribute,
        total: total,
        selected: selected,
      };
    });


    let daterange = null;
    const { account_name } = userDetails;
    if (filterSettings.date_range) {
      let { start_date, end_date, end_date_cy } = filterSettings.date_range;
      if (account_name === 'Alembic') {
        end_date = '2025-04-30';
      }
      daterange = [
        {
          startDate: new Date(start_date),
          endDate: new Date(end_date),
          endDateCY: end_date_cy ? new Date(end_date_cy) : new Date(end_date),
          key: 'selection',
        },
      ];
    }
    appCtx.batchUpdateAppFilters({
      [FILTER_NAMES.PARAMETER]: parameters,
      [FILTER_NAMES.DATERANGE]: daterange ?? defaultDRange,
      [FILTER_NAMES.CALC_DATERANGE]: daterange ?? defaultDRange,
    });
  }

  useEffect(() => {
    const userDetails = JSON.parse(localStorage.getItem('USER_DETAILS'));
    userDetails && fetchData();
  }, []);
}
